import { StayResourceManagementFeaturePage } from "../ui";

/** 房资源管理稳定路由入口。 */
export function StayResourceManagementPage() {
  return <StayResourceManagementFeaturePage />;
}
